import type { Theme } from '@/stores/preferences';

export const PREFERENCES_KEY: string = 'app:preferences';
export const PREFERENCES_VERSION: number = 0;

export const DEFAULT_THEME: Theme = 'system';
